import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';

import {FXResponse} from 'src/app/models/response.model';
import {standardizeParam} from 'src/app/shared/utils/helper';
import {MapUtils} from 'src/app/shared/utils/mapper';
import {APP_CONFIG} from 'src/app/shared/common/config';
import {Profit} from 'src/app/models/fund-performance.model';
import {Socket} from 'ngx-socket-io';
import {TotalProfit} from 'src/app/models/dashboard.model';
import {DUMMY_DATA} from 'src/app/shared/utils/data';
import { DashboardSummary } from './models/dashboard-sumary.interface';
import { DashboardDataRequest } from './models/dashboard-data-request.interface';

@Injectable()
export class DashboardService {
  // // URL to web api.
  constructor(private http: HttpClient, private socket: Socket) {}


  getDashboardCommon(type, params): Observable<FXResponse<any>> {
    const url = `${APP_CONFIG.BASE_API_LINK.DASHBOARD}/common/${type}?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        }),
      );
  }
  getDashboardHistory(type, params): Observable<FXResponse<any>> {
    const url = `${APP_CONFIG.BASE_API_LINK.DASHBOARD}/common/${type}/history?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          return response;
        }),
      );
  }

  getProfits(params: any): Observable<FXResponse<Profit[]>> {
    return new Observable<FXResponse<Profit[]>>((observer) => {
      const res = DUMMY_DATA.DASHBOARD.PROFIT[params.name.toUpperCase()];
      observer.next(res);
      observer.complete();
    }).pipe(
      retry(10),
      map((res: any) => {
        const data = res.data.points;
        const response = new FXResponse<Profit[]>().deserialize(res);
        response.metadata = {
          type: params.type,
          name: params.name,
          startPoint: res.data.start_point,
          endPoint: res.data.end_point,
        };
        response.data = data.map((p: any) => {
          return MapUtils.deserialize(Profit, p);
        });
        return response;
      })
    );
    // return this.http
    //   .get(
    //     `${APP_CONFIG.BASE_API_LINK.DASHBOARD}/profit-chart?${standardizeParam(
    //       params
    //     )}`
    //   )
    //   .pipe(
    //     retry(10),
    //     map((res: any) => {
    //       const data = res.data.points;
    //       const response = new FXResponse<Profit[]>().deserialize(res);
    //       response.metadata = {
    //         type: params.type,
    //         name: params.name,
    //         startPoint: res.data.start_point,
    //         endPoint: res.data.end_point,
    //       };
    //       response.data = data.map((p: any) => {
    //         return MapUtils.deserialize(Profit, p);
    //       });
    //       return response;
    //     })
    //   );
  }

  getSummary(): Observable<FXResponse<DashboardSummary>> {
    const url = `${APP_CONFIG.BASE_API_LINK.DASHBOARD}?${standardizeParam({
      all: 1,
    })}`;
    return this.http.get<FXResponse<DashboardSummary>>(url);
  }

  getData(
    params: DashboardDataRequest
  ): Observable<FXResponse<DashboardSummary[]>> {
    const url = `${APP_CONFIG.BASE_API_LINK.DASHBOARD}?${standardizeParam(
      params
    )}`;
    return this.http.get<FXResponse<DashboardSummary[]>>(url);
  }
}
